import * as React from 'react';
import { Spin } from 'antd';

interface LoaderProps{
}

interface LoaderState{
}

export default class Loader extends React.Component<LoaderProps, LoaderState>{
  constructor(props: LoaderProps) {
    super(props);
  }

  render() {
    return <div style={{ color: '#000' }}>Loading... <Spin /></div>;
  }
}
